module.exports = __webpack_public_path__ + "img/course_tabInfoText.dfd6ddf5.png";